import { useQuery } from '@tanstack/vue-query';

import { anykrowdApi } from '@/api/anykrowdApi';
import type { TenantConfig, TenantStyles } from '@/shared/interfaces/tenant';
import useStorageService from '@/shared/composables/useStorageService';

const { get, set } = useStorageService();

// Get config
const getConfig = async (): Promise<TenantConfig> => {
	// Get tenant options
	try {
		if (window.apiUrl !== 'REPLACE_API_URL') {
			const { data } = await anykrowdApi.get<TenantConfig>('/tenant/config', false);
			set('tenantConfig', data);
			return data;
		} else {
			return await get('tenantConfig');
		}
	} catch (error) {
		console.error('Error fetching tenant config:', error);
		return await get('tenantConfig');
	}
};

// Get styles
const getStyles = async (): Promise<TenantStyles> => {
	// Get tenant styles
	try {
		if (window.apiUrl !== 'REPLACE_API_URL') {
			const { data } = await anykrowdApi.get<TenantStyles>('/tenant/styles', false);
			set('tenantStyles', data);
			return data;
		} else {
			return await get('tenantStyles');
		}
	} catch (error) {
		console.error('Error fetching tenant styles:', error);
		return await get('tenantStyles');
	}
};

// getTenantConfigAndStyles
const getTenantConfigAndStyles = () => {
	// Tenant Config
	// const tenantConfig = ref<TenantConfig>()!;
	const { data: tenantConfig, isSuccess: isSuccessTenantConfig } = useQuery({
		queryKey: ['tenantConfig'],
		queryFn: () => getConfig(),
		enabled: !window.apiUrl.includes('REPLACE_API_URL'),
		cacheTime: 1000 * 60 * 60 * 24 * 365, // Keep long cache for offline availability
		staleTime: 0, // Always try to refresh when online
		retry: 3,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
	});

	// watch(
	// 	tenantConfigData,
	// 	() => {
	// 		if (tenantConfigData.value) {
	// 			tenantConfig.value = { ...tenantConfigData.value };
	// 		}
	// 	},
	// 	{ immediate: true },
	// );

	// Tenant Styles
	// const tenantStyles = ref<TenantStyles>()!;
	const { data: tenantStyles, isSuccess: isSuccessTenantStyles } = useQuery({
		queryKey: ['tenantStyles'],
		queryFn: () => getStyles(),
		enabled: !window.apiUrl.includes('REPLACE_API_URL'),
		cacheTime: 1000 * 60 * 60 * 24 * 365, // Keep long cache for offline availability
		staleTime: 0, // Always try to refresh when online
		retry: 3,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
	});

	// watch(
	// 	tenantStylesData,
	// 	() => {
	// 		if (tenantStylesData.value) {
	// 			tenantStyles.value = { ...tenantStylesData.value };
	// 		}
	// 	},
	// 	{ immediate: true },
	// );

	function anySocialLoginEnabled() {
		return tenantConfig?.value?.enable_apple_login || tenantConfig?.value?.enable_facebook_login || tenantConfig?.value?.enable_google_login;
	}

	function showLoggedData() {
		return tenantConfig?.value?.enable_full_guest_mode === false;
	}

	// Return
	return {
		isSuccessTenantConfig,
		isSuccessTenantStyles,
		tenantConfig,
		tenantStyles,
		anySocialLoginEnabled,
		showLoggedData,
	};
};

const useTenant = () => {
	// Return
	return {
		getConfig,
		getStyles,
		getTenantConfigAndStyles,
	};
};

export default useTenant;
